<template>
  <!-- 复核日志 -->
  <a-card :bordered="false">
    <div class="table-page-search-wrapper">
      <a-form layout="inline" class="search-form">
        <a-row :gutter="16">
          <a-col :md="6" :sm="12">
            <a-form-item label="用户">
              <UserSelect v-model="query.userCode" @change="onUserSelectChange" />
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="12">
            <a-form-item label="抄表员">
              <a-select placeholder="请选择抄表员" v-model="query.readerId" allow-clear style="width: 100%">
                <a-select-option v-for="item in meterReaderList" :key="item.id" :value="item.id">
                  {{ item.readerName }}
                </a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="12">
            <a-form-item label="表册分组">
              <a-select placeholder="请选择表册分组" v-model="query.groupId" allow-clear @change="onQueryGroupChange" style="width: 100%">
                <a-select-option v-for="item in bookGroupList" :key="item.id" :value="item.id">
                  {{ item.groupName }}
                </a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="12">
            <a-form-item label="表册">
              <a-select 
                placeholder="请选择表册" 
                v-model="query.bookId" 
                allow-clear 
                show-search
                :filter-option="filterMeterBookOption"
                :disabled="!query.groupId" 
                style="width: 100%"
              > 
                <a-select-option v-for="item in meterBooksList" :key="item.id" :value="item.id">
                  {{ item.bookName }}
                </a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-form-item class="button-group">
              <a-button type="primary" icon="search" @click="queryList">查询</a-button>
              <a-button icon="reload" @click="resetList" style="margin-left: 10px">重置</a-button>
            </a-form-item>
          </a-col>
        </a-row>
      </a-form>
    </div>
    <a-table
      size="middle"
      rowKey="id"
      bordered
      :row-selection="{ selectedRowKeys: this.selectedRows, onChange: onSelectChange }"
      :row-class-name="(_record, index) => (index % 2 === 1 ? 'table-striped' : null)"
      :data-source="list"
      :columns="columns"
      :loading="dataListLoading"
      :pagination="pagination"
      @change="pageChange"
      :scroll="{ x: 1800 }"
    >
      <template slot="revised" slot-scope="text">
        <span :style="{ color: 'red' }"> {{ text }}</span> </template
      >>
      <span slot="action" slot-scope="text, record">
        <div class="action-container">
          <a @click="viewOriginalImage(record)">抄表图片</a>
        </div>
      </span>
    </a-table>

    <!-- 图片预览模态框 -->
    <a-modal
      title="图片预览"
      style="top: 20px"
      :width="800"
      :footer="null"
      :visible="imagePreviewVisible"
      @cancel="handleImagePreviewCancel"
    >
      <div class="image-preview-container">
        <img v-if="previewImageUrl" :src="previewImageUrl" alt="图片预览" class="preview-image" />
      </div>
    </a-modal>
  </a-card>
</template>

<script>
import mixinViewModule from '@/mixin/common'
import UserSelect from '@/views/meter-reading/components/UserSelect.vue'


const columns = [
  { title: '用户编码', dataIndex: 'userCode', key: 'userCode', width: 120 },
  { title: '用户名称', dataIndex: 'userName', key: 'userName', width: 120 },
  { title: '水表编号', dataIndex: 'meterNumber', key: 'meterNumber', width: 120 },
  { title: '用户地址', dataIndex: 'userAddress', ellipsis: true, width: 200, key: 'userAddress' },
  { title: '表册分组', dataIndex: 'groupName', key: 'groupName', width: 100 },
  { title: '所属表册', dataIndex: 'bookName', ellipsis: true, width: 120, key: 'bookName' },
  { title: '抄表员', dataIndex: 'readerName', key: 'readerName', width: 100 },
  { title: '抄表时间', dataIndex: 'readingTime', key: 'readingTime', width: 150 },

  { title: '上期行至', dataIndex: 'originalReading', key: 'originalReading', width: 100 },
  { title: '本期行至（原始）', dataIndex: 'currentReading', key: 'currentReading', width: 120 },
  {
    title: '本期行至（修正）',
    dataIndex: 'reviewedReading',
    scopedSlots: { customRender: 'reviewedReading' },
    key: 'reviewedReading',
    width: 120,
  },
  {
    title: '本期用水量（修正）',
    dataIndex: 'reviewedConsumption', 
    width: 120,
    key: 'reviewedConsumption', 
  },
  { title: '补充水量', dataIndex: 'supplementWater', key: 'supplementWater', width: 100 },
  { title: '复核人', dataIndex: 'reviewedName', key: 'reviewedName', width: 100 },
  { title: '复核时间', dataIndex: 'reviewedAt', key: 'reviewedAt', width: 150 },
  { title: '备注', dataIndex: 'reassignReason', width: 120, key: 'reassignReason' },
  {
    title: '操作',
    width: 80,
    dataIndex: 'action',
    scopedSlots: { customRender: 'action' },
    key: 'action',
    fixed: 'right',
  },
]

export default {
  components: {
    UserSelect,
  },
  mixins: [mixinViewModule],
  name: 'ReviewLog',
  data() {
    return {
      imagePreviewVisible: false,
      previewImageUrl: '',
      queryUrl: '/meter-manager/review_records/page',
      query: {
        userCode: '',
        readerId: '',
        groupId: '',
        bookId: '',
      },
      columns,
      meterReaderList: [], // 抄表员列表
      bookGroupList: [], // 表册分组列表
      meterBooksList: [], // 表册列表
    }
  },

  created() {
    this.getMeterReaderData()
    this.getBookGroupData()
  },
  methods: {
    onUserSelectChange(value, user) {
      console.log('用户选择变化:', value, user)
      if (user) {
        this.query.userName = user.userName
        console.log('设置用户名:', user.userName)
      } else {
        this.query.userName = ''
        console.log('清空用户名')
      }
      this.queryList && this.queryList()
    },
    getMeterReaderData() {
      this.$http.get('/meter-manager/meter_readers/list').then(({ data }) => {
        this.meterReaderList = data
      })
    },
    getBookGroupData() {
      this.$http.get('/meter-manager/meter_book_groups/list').then(({ data }) => {
        this.bookGroupList = data || []
      })
    },
    getMeterBooksData(groupId = null) {
      if (!groupId) {
        this.meterBooksList = []
        return
      }
      this.$http
        .get(`/meter-manager/meter_reading_plans/meter-books?groupId=${groupId}`)
        .then(({ data }) => {
          this.meterBooksList = Array.isArray(data) ? data : data.list || data.data || []
        })
        .catch(() => {
          this.meterBooksList = []
        })
    },
    onQueryGroupChange() {
      this.query.bookId = ''
      if (this.query.groupId) {
        this.getMeterBooksData(this.query.groupId)
      } else {
        this.meterBooksList = []
      }
    },

    // 查看原始图片
    viewOriginalImage(record) {
      if (record.originalImageUrl) {
        this.previewImage(record.originalImageUrl)
      } else {
        this.$message.info('该记录暂无图片')
      }
    },

    // 查看复核图片
    viewReviewImage(record) {
      if (record.reviewImageUrl) {
        this.previewImage(record.reviewImageUrl)
      } else {
        this.$message.info('该记录暂无复核图片')
      }
    },

    // 预览图片
    previewImage(imageUrl) {
      this.previewImageUrl = imageUrl
      this.imagePreviewVisible = true
    },

    // 关闭图片预览
    handleImagePreviewCancel() {
      this.imagePreviewVisible = false
      this.previewImageUrl = ''
    },

    // 表册搜索过滤函数
    filterMeterBookOption(input, option) {
      return option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
    },
  },
}
</script>

<style lang="less" scoped>
/deep/.table-striped {
  background-color: #fafafa;
}

/deep/.ant-table-thead > tr > th > {
  text-align: center;
}

/deep/.ant-table-tbody > tr > td {
  text-align: center;
}

/deep/ .ant-modal-body {
  padding: 0 24px 24px 24px;
}



/* 图片预览样式 */
.image-preview-container {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 400px;
}

.preview-image {
  max-width: 100%;
  max-height: 500px;
  object-fit: contain;
  border-radius: 4px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
}

.action-container {
  display: flex;
  align-items: center;
  gap: 4px;
}

.action-container a {
  font-size: 12px;
  padding: 2px 4px;
}
</style>
